import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {RequestExecutor} from '../libraries/request-executor';
import {ConversationId} from '../libraries/conversation-id';
import {Constants} from '../constants';
import {environment} from '../../../environments/environment';
import entries from 'lodash-es/entries';

@Injectable({
    providedIn: 'root'
})
export class ConfigService extends RequestExecutor {
    /**
     * App configuration object
     * @var {object}
     */
    private _config: any = {};

    /**
     * Environment variables
     */
    private _envVars: any = {};

    /**
     * Class constructor
     *
     * @param _conversationId
     * @param _httpClient
     */
    constructor(
        protected _conversationId: ConversationId,
        protected _httpClient: HttpClient
    ) {
        super(_conversationId, _httpClient);
    }

    /**
     * Sets the current request headers
     *
     * @param requestHeaders
     * @returns {ConfigService}
     */
    public setRequestHeaders(requestHeaders?: object): ConfigService {
        super.setRequestHeaders(requestHeaders || {});

        return this;
    }

    /**
     * Sets the current request body
     *
     * @param requestBody
     * @returns {ConfigService}
     */
    public setRequestBody(requestBody?: object): ConfigService {
        super.setRequestBody(requestBody || {});

        return this;
    }

    /**
     * Return the loaded configuration object
     *
     * @returns {object}
     */
    public getConfig(): object {
        return this._config.config;
    }

    /**
     * Return the configured environment variables
     *
     * @returns {object}
     */
    public getEnvVars(): object {
        for (let [key, value] of entries(this._config.env_vars)) {
            key = key.replace('UI_VAR_', '');

            this._envVars[key] = value;
        }

        return this._envVars;
    }

    /**
     * Loads the configuration object from the API endpoint
     *
     * @returns {Promise<any>}
     */
    public loadConfig(): Promise<any> {
        // TODO add xconversationId header
        return new Promise((resolve, reject) => {
            this.executeRequest(
                Constants.REQUEST_TYPE_GET,
                `${environment.apiConfiguration.basePath}${environment.apiConfiguration.paths.config}`
            )
                .subscribe(
                    (config: any) => {
                        this._config = config;
                        resolve(config);
                    },
                    (error: any) => {
                        reject(error);
                    }
                );
        });
    }
}
